import Image from "components/base/Image";
import { MotionBox as Box, fadeIn } from "utils/motion";

export default function ImageSection({ image, alt, ...props }) {
  return (
    <Box
      initial="hidden"
      variants={fadeIn}
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      width="100%"
      minHeight={["100%", null, "100vh"]}
      display="flex"
      position="relative"
      flexDirection="column"
      justifyContent="space-between"
      {...props}
    >
      <Image
        src={image}
        alt={alt}
        objectPosition="center"
        objectFit="cover"
        minHeight={["60vh", null, "100vh"]}
        priority
      />
    </Box>
  );
}
